/* eslint-disable import/prefer-default-export */

import axios from './axios';

export const getActivityLogs = ({ params } = {}) => axios.get(`activity_log`, { params });
